import React from 'react';
import { bonuses, pricing } from '../data/bonuses';
import { BonusCard } from './BonusCard';
export function Bonuses() {
  return <section id="bonuses" className="bg-navy px-4 py-12 md:py-16" data-id="element-30" data-mp="pjg4jxu631zc">
      <div className="mx-auto max-w-3xl text-center" data-id="element-31" data-mp="avv308cxxatj">
        <h2 className="font-display text-xl font-black uppercase leading-tight text-white md:text-3xl" data-id="element-32" data-mp="asz3wgpcwg3i">
          And today, you also get <span className="text-brand-light" data-id="element-33" data-mp="1un4bp6ii7yx">5 practical bonuses</span>
        </h2>
        <p className="mt-3 font-display text-xs font-extrabold uppercase text-white/80 md:text-sm" data-id="element-34" data-mp="5w0c44t60l8h">
          Included at no extra cost.
        </p>
      </div>

      <div className="mx-auto mt-8 grid max-w-6xl gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-35" data-mp="3o3680bs3yueo">
        {bonuses.map(bonus => <BonusCard key={bonus.number} bonus={bonus} data-id="element-36" data-mp="3t2sp4wb24usr" />)}
        <div className="flex flex-col items-center justify-center rounded-2xl border-2 border-brand-light/60 p-5 text-center" data-id="element-37" data-mp="1mbjoevajq1s8">
          <p className="text-[11px] font-extrabold uppercase tracking-wider text-white/80" data-id="element-38" data-mp="1r78rv9pos2tt">
            Total individual bonus value
          </p>
          <span className="mt-1 font-display text-3xl font-black text-white/80 line-through decoration-red-500 decoration-4" data-id="element-39" data-mp="3dg4zmynvy6l9">
            ${pricing.bonusValue} USD
          </span>
          <p className="mt-1 font-display text-base font-black uppercase text-brand-light" data-id="element-40" data-mp="3n5esigqjztaf">All 5 included free today</p>
        </div>
      </div>
    </section>;
}